<div class="card" id="scatterChart">
    <figure id="scatter"></figure>
</div>